import {GetMetaTable} from "../../components/TableComponents/utils/table_helpers";
import {CELL_SIZES, SAMPLE_TYPES_CODES, TEST_TYPES} from "../../utils/constants";
import {PrintCell} from "../../components/TableComponents/utils/table_formatters";

export const PrepareSamplesForPDF = (samples) => {
	const selectedSamples = samples
	
	if (selectedSamples.length === 0) {
		return
	}
	
	let selectedSampleData = []
	
	for (let i = 0; i < samples.length; i++) {
		selectedSampleData.push(
			SampleToPrint(samples[i])
		)
	}
	
	let sortedSamplesList = []
	
	if (samples[0].sample_type === SAMPLE_TYPES_CODES.solo) {
		sortedSamplesList = SortSoloSamplesForReport(selectedSampleData)
	} else if (samples[0].sample_type === SAMPLE_TYPES_CODES.bulk) {
		sortedSamplesList = SortBulkSamplesForReport(selectedSampleData)
	}else if (samples[0].sample_type === SAMPLE_TYPES_CODES.herd) {
		sortedSamplesList = SortHerdSamplesForReport(selectedSampleData)
	}else{
		sortedSamplesList = selectedSampleData
	}
	
	return sortedSamplesList
}

export const SampleToPrint = (sample) => {
	const metaTable = GetMetaTable(sample.sample_type)
	
	const sampleKeys = Object.keys(sample)
	
	let printSample = {}
	
	for(let i = 0; i < sampleKeys.length; i++){
		const attributeDetails = metaTable.find(column => column.name === sampleKeys[i])
		
		if(attributeDetails){
			if (
				sample.test_type.includes("Lost In Transit") &&
				(sampleKeys[i] === "binary_nsg" || sampleKeys[i] === "bulk_staph_aureus" || sampleKeys[i] === "component_fat")
			) {
				
				printSample[sampleKeys[i]] = {
					value: TEST_TYPES.lost_in_transit,
					columnSize: CELL_SIZES.medium
				}
				
				continue
			}
			
			printSample[sampleKeys[i]] = {
				value: PrintCell(attributeDetails, sample),
				columnSize: attributeDetails.cellSize,
			}
		}else if(sampleKeys[i] === "sample_submit_date"){
			printSample[sampleKeys[i]] = {
				value: sample[sampleKeys[i]],
				columnSize: CELL_SIZES.medium
			}
		}
	}
	
	return printSample
}

const ContagiousCheck = (sample, sampleType) => {
	if (sampleType === SAMPLE_TYPES_CODES.solo || sampleType === SAMPLE_TYPES_CODES.herd) {
		return sample.strep_ag.value === '+' || sample.staph_aureus.value === '+' || sample.binary_day4.value === '+' || sample.binary_day7.value === '+'
	} else if (sampleType === SAMPLE_TYPES_CODES.bulk){
		return (sample.bulk_strep_ag.value && (sample.bulk_strep_ag.value !== "0" || sample.bulk_strep_ag.value !== "NSG")) || (sample.bulk_staph_aureus.value && (sample.bulk_staph_aureus.value !== '0' || sample.bulk_staph_aureus.value !== "NSG")) || sample.bulk_myco_day4.value === '+' || sample.bulk_myco_day7.value === '+' || sample.bulk_myco_broth === '+'
	}
}

const MastitisCheck = (sample) => {
	return (
		sample.individual_sample_type.value !== null &&
		sample.individual_sample_type.value.toLowerCase() !== "f" &&
		sample.individual_sample_type.value.toLowerCase() !== "fresh" &&
		sample.individual_sample_type.value !== ""
	)
}

const LostInTransitCheck = (sample) => {
	if(sample.binary_nsg){
		return sample.binary_nsg.value === 'L.I.T.'
	}else if(sample.bulk_staph_aureus){
		return sample.bulk_staph_aureus.value === 'L.I.T.'
	}
}

const SortByCowID = (samples) => {
	const collator = Intl.Collator("en", {numeric: true, sensitivity: "base"})
	
	return samples.sort((a, b) => collator.compare(a.binary_cow_id.value, b.binary_cow_id.value))
}

const CompareCowIds = (a, b) => {
	if(parseInt(a) && !parseInt(b)){
		return true
	}else if(parseInt(a) && parseInt(b)){
		return parseInt(a) <= parseInt(b)
	}else if(!parseInt(a) && parseInt(b)){
		return false
	}else{
		return a <= b
	}
}

export const SortSoloSamplesForReport = (samples) => {
	let contagiousList = []
	let nonContagiousList = []
	let litList = []
	
	let samplesIndex = 0
	
	for(samplesIndex; samplesIndex < samples.length; samplesIndex++) {
		const sample = samples[samplesIndex]
		
		let currentList = nonContagiousList
		
		if(LostInTransitCheck(sample)){
			if(litList.length === 0){
				litList.push(sample)
				continue
			}
			currentList = litList
		}else if(ContagiousCheck(sample, SAMPLE_TYPES_CODES.solo)){
			if(contagiousList.length === 0){
				contagiousList.push(sample)
				continue
			}
			currentList = contagiousList
		}else if(nonContagiousList.length === 0){
			nonContagiousList.push(sample)
			continue
		}
		
		for(let i = 0; i < currentList.length; i++){
			if(sample.sample_date.value < currentList[i].sample_date.value){
				currentList.splice(i, 0, sample)
				break
			}
			
			if(sample.sample_date.value === currentList[i].sample_date.value){
				if(sample.sample_submit_date.value < currentList[i].sample_submit_date.value){
					currentList.splice(i, 0, sample)
					break
				}
				
				if(sample.sample_submit_date.value === currentList[i].sample_submit_date.value){
					if(MastitisCheck(sample) && !MastitisCheck(currentList[i])){
						currentList.splice(i, 0, sample)
						break
					}
					
					if(MastitisCheck(sample) && MastitisCheck(currentList[i])){
						if(CompareCowIds(sample.binary_cow_id.value, currentList[i].binary_cow_id.value)){
							currentList.splice(i, 0, sample)
							break
						}
					}
					
					if(!MastitisCheck(sample) && !MastitisCheck(currentList[i])) {
						if (CompareCowIds(sample.binary_cow_id.value, currentList[i].binary_cow_id.value)) {
							currentList.splice(i, 0, sample)
							break
						}
					}
				}
			}
			
			if(i + 1 === currentList.length){
				currentList.splice(i+1, 0, sample)
				break
			}
		}
	}
	
	return contagiousList.concat(nonContagiousList, litList)
}

export const SortHerdSamplesForReport = samples => {
	// declare lists for categories and then use those to sort by cowID
	let contagiousList = []
	let nonMastitisAndContagiousList = []
	let litList = []
	
	let samplesIndex = 0
	
	for(samplesIndex; samplesIndex < samples.length; samplesIndex++){
		let sample = samples[samplesIndex]
		
		if(LostInTransitCheck(sample)){
			litList.push(sample)
		}else if(ContagiousCheck(sample, SAMPLE_TYPES_CODES.herd)){
			contagiousList.push(sample)
		}else{
			nonMastitisAndContagiousList.push(sample)
		}
	}
	
	SortByCowID(contagiousList)
	SortByCowID(nonMastitisAndContagiousList)
	SortByCowID(litList)
	
	return contagiousList.concat(
		nonMastitisAndContagiousList,
		litList
	)
}

export const SortBulkSamplesForReport = (samples) => {
	let contagiousList = []
	let regularList = []
	let litList = []
	
	let samplesIndex = 0
	
	for(samplesIndex; samplesIndex < samples.length; samplesIndex++) {
		const sample = samples[samplesIndex]
		
		if(LostInTransitCheck(sample)){
			litList.push(sample)
		}else if(ContagiousCheck(sample, SAMPLE_TYPES_CODES.bulk)){
			contagiousList.push(sample)
		}else{
			regularList.push(sample)
		}
	}
	
	return contagiousList.concat(regularList, litList)
}